import {
  getPricingOption,
  getPricingOptions,
  hasPricingOptions,
  hasSinglePricingOption,
  isDonationTicketDefinition,
} from '@wix/wix-events-commons-statics'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {getActivePricingOptionId, isPlaceReservableAsWhole} from '../../../../../selectors/seating/place'
import {getAbstractFees, getAdditionalFeesNote, getFees} from '../../../../../selectors/tax-and-fee'
import {TicketFeesProps} from './interfaces'
import {classes} from './ticket-fees.st.css'

export const TicketFees = ({place, inPopover, forceAbstractFees, id}: TicketFeesProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const {ticket} = place
  const hasPriceOverride = isDonationTicketDefinition(ticket) || hasPricingOptions(ticket)
  const abstractFees = (ticket && inPopover && hasPriceOverride && !hasSinglePricingOption(ticket)) || forceAbstractFees

  const event = useAppSelector(getEvent)

  const getPriceOverride = () => {
    if (isDonationTicketDefinition(ticket)) {
      return place.donation
    }

    if (hasPricingOptions(ticket)) {
      if (hasSinglePricingOption(ticket)) {
        const pricingOptionId = getPricingOptions(ticket)[0].id

        return getPricingOption(ticket, pricingOptionId)?.price.amount
      } else if (!isPlaceReservableAsWhole(place)) {
        const pricingOptionId = getActivePricingOptionId(place)

        return getPricingOption(ticket, pricingOptionId)?.price.amount
      }
    }
  }

  const fees = () => {
    if (abstractFees) {
      return getAbstractFees({event, ticket, t, getFormattedMoney})
    }

    const overridePrice = getPriceOverride()

    return getFees({event, ticket, t, getFormattedMoney, overridePrice})
  }

  const additionalFeesNote = getAdditionalFeesNote({event, ticket, t})

  return (
    <div id={id}>
      <Text className={classes.text}>{fees()}</Text>
      {additionalFeesNote ? <Text className={classes.text}>{additionalFeesNote}</Text> : null}
    </div>
  )
}
